export default class PaginatedSummarisedAllowances {
  constructor(paginate) {
    this.total = paginate.total
    this.per_page = paginate.per_page
    this.current_page = paginate.current_page
    this.data = paginate.data
  }
}
